import Class from './Class';
import ExerciseForm from './ExerciseForm';
import { isNull } from 'util';

export default class ClassForm {
  constructor(audio = null, categories = [], description = '', duration = [], equipment = [], exercisevideos = [], id = null, image = null, intensity_level = null, musclegroup = [], picture = "", published = null, sets = [], tags = [], template = null, title = '',trainer = null, video = isNull, primaryStatus = null, statuses = [], premium_required = false, is_dc = null) {
    this.audio = audio;
    this.categories = categories;
    this.description = description;
    this.duration = duration;
    this.equipment = equipment;
    this.exercisevideos = exercisevideos;
    this.id = id;
    this.image = image;
    this.intensity_level = intensity_level;
    this.musclegroup = musclegroup;
    this.picture = picture;
    this.published = published;
    this.sets = sets;
    this.tags = tags;
    this.template = template;
    this.title = title;
    this.trainer = trainer;
    this.video = video;
    this.primaryStatus = primaryStatus;
    this.statuses = statuses;
    this.premium_required = premium_required;
    this.is_dc = is_dc;
  }

  formatforDB() {
    const data = {
      audio: this.audio,
      categories: this.categories.map( item => item.toLowerCase().replace(/\s+/g, '-') ),
      description: this.description,
      duration: this.duration,
      equipment: this.equipment,
      exercisevideos: this.getExerciseVideos(),
      id: this.id,
      image: this.image ? this.image.id : null,
      intensity_level: this.intensity_level,
      premium_required: this.premium_required,
      is_dc : this.is_dc,
      musclegroup: this.musclegroup,
      picture: this.picture,
      published: this.published,
      sets: this.constructSets(this.sets),
      tags: this.tags.map(item => item.value),
      template: this.template,
      title: this.title,
      trainer: this.trainer,
      video: this.video ? this.video.id : null,
    }

    return new Class(
      data.audio,
      data.categories,
      data.description,
      data.duration,
      data.equipment,
      data.exercisevideos,
      data.id,
      data.image,
      data.intensity_level,
      data.musclegroup,
      data.picture,
      data.published,
      data.sets,
      data.tags,
      data.template,
      data.title,
      data.trainer,
      data.video,
      data.premium_required,
      data.is_dc,
    );
  }

  formatForForm(obj) {
    const exer = new Class();
    if(obj) {
      for (const key in exer) {
        if (obj.hasOwnProperty(key)) {
          exer[key] = obj[key];
        }
      }
    }

    this.audio = exer.audio;
    this.categories = exer.categories;
    this.description = exer.description;
    this.duration = exer.duration;
    this.equipment = exer.equipment;
    this.exercisevideos = exer.exercisevideos;
    this.id = exer.id;
    this.image = exer.image;
    this.intensity_level = exer.intensity_level;
    this.premium_required = exer.premium_required;
    this.musclegroup = exer.musclegroup;
    this.picture = exer.picture;
    this.published = exer.published;
    this.sets = exer.sets;
    this.is_dc = exer.is_dc;

    for (let i = 0; i < this.sets.length; i++) {
      for (let j = 0; j < this.sets[i].activities.length; j++) {
        if (this.sets[i].activities[j].duration === null) {
          this.sets[i].activities[j].duration = this.sets[i].activities[j].activity_type === 'timed' ? 30 : 10;
        }
      }
    }

    this.tags = exer.tags.map(item => ({label: item, value: item}));
    this.template = exer.template;
    this.title = exer.title;
    this.trainer = exer.trainer;
    this.video = exer.video;

    this.checkValidity();
  }

  getExerciseIds() {
    let exerciseIds = [];
    for(let i = 0; i < this.sets.length; i++) {
      const setObj = this.sets[i];
      const activities = setObj["activities"];
      for(let j = 0; j < activities.length; j++) {
        const activityObj = activities[j];
        if(activityObj.exercise) {
          exerciseIds.push(activityObj.exercise.id);
        }
      }
    }
    return exerciseIds;
  }

  getExerciseVideos() {
    let exercisevideos = [];
    for (let i = 0; i < this.sets.length; i++) {
      const setObj = this.sets[i];
      const activities = setObj["activities"];
      for (let j = 0; j < activities.length; j++) {
        const activityObj = activities[j];
        if (activityObj.exercise && activityObj.exercise.video && activityObj.exercise.video.length) {
          const exerciseIndex = exercisevideos.findIndex(item => item.exercise_id === activityObj.exercise.id);
          if (exerciseIndex < 0) {
            exercisevideos.push({
              exercise_id: activityObj.exercise.id,
              exercisevideo_id: activityObj.exercise.video[0].id
            });
          }
        }
      }
    }
    return exercisevideos;
  }

  constructSets(sets) {
    const mockSets = [...sets];
    for(let i = 0; i < mockSets.length; i++) {
      const setObj = Object.assign({}, mockSets[i]);
      const activities = [...setObj["activities"]];
      for(let j = 0; j < activities.length; j++) {
        const activityObj = Object.assign({}, activities[j]);
        if(activityObj.exercise) {
          activityObj.exercise = activityObj.exercise.id;
        } else {
          delete activityObj.exercise;
        }
        activities[j] = activityObj;
      }
      setObj["activities"] = activities;
      mockSets[i] = setObj;
    }
    return mockSets;
  }

  checkSetsValidity() {
    const validity = { emptySet: false, hasZero: {set:false, exercise:false, rest:false}, atLeastOne: false, hasNull: false, inValid: false };
    const mockSets = this.sets;
    for(let i = 0; i < mockSets.length; i++) {
      const setObj = Object.assign({}, mockSets[i]);
      const activities = [...setObj["activities"]];
      if(setObj && (setObj.sets === null || !Number.isInteger(setObj.sets) || setObj.sets === 0)) {
        validity.hasZero.set = true;
      }
      if(setObj && setObj.activities.length === 0) {
        validity.emptySet = true;
      }
      for(let j = 0; j < activities.length; j++) {
        const activityObj = Object.assign({}, activities[j]);
        if(activityObj && (activityObj.duration === null || !Number.isInteger(activityObj.duration) || activityObj.duration === 0)) {
          if(activityObj.activity_type === 'rest') {
            validity.hasZero.rest = true;
          } else {
            validity.hasZero.exercise = true;
          }
        }
        if(activityObj.activity_type === 'rest') {
          //skip rests
        } else if(activityObj.exercise) {
          
          const exer = new ExerciseForm();
          exer.formatForForm(activityObj.exercise);
          validity.atLeastOne = true;
          if(exer.primaryStatus !== 'Valid') {
            validity.inValid = true;
          }
        } else {
          validity.hasNull = true;
        }
      }
    }
    // if not at least one exercise, they can't be valid
    if(!validity.atLeastOne) {
      validity.inValid = true;
      validity.hasZero.exercise = true;
    }
    return validity;
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};
    const titleText = 'Class title';
    const imageText = 'Class has a thumbnail picture to represent the class';
    const categoriesText = 'Class has at least one category';
    const musclegroupText = 'Class has at least one muscle group';
    const tagsText = 'Class has at least one tag';
    const intensity_levelText = 'Class has an intensity level';

    const exercise1Text = 'Each set has at least 1 exercise';
    const exercise2Text = 'Exercises are complete';
    const exercise3Text = 'Class has at least 1 exercise';

    const exercise4Text = 'All sets have a value greater than 0';
    const exercise5Text = 'All exercises have a time or rep value greater than 0';
    const exercise6Text = 'All rest times have a value is greater than 0';

    if(this.title !== '') {
      statusList.title = {value: true, text: titleText};
    } else {
      primaryStatus = 'Invalid';
      statusList.title = {value: false, text: titleText};
    }

    const { atLeastOne, hasNull, inValid, hasZero, emptySet } = this.checkSetsValidity();

    if(!emptySet) {
      statusList.exercise1 = {value: true, text: exercise1Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise1 = {value: false, text: exercise1Text};
    }

    if(!hasNull && !inValid) {
      statusList.exercise2 = {value: true, text: exercise2Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise2 = {value: false, text: exercise2Text};
    }

    if(atLeastOne) {
      statusList.exercise3 = {value: true, text: exercise3Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise3 = {value: false, text: exercise3Text};
    }

    if(!hasZero.set) {
      statusList.exercise4 = {value: true, text: exercise4Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise4 = {value: false, text: exercise4Text};
    }

    if(!hasZero.exercise) {
      statusList.exercise5 = {value: true, text: exercise5Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise5 = {value: false, text: exercise5Text};
    }

    if(!hasZero.rest) {
      statusList.exercise6 = {value: true, text: exercise6Text};
    } else {
      primaryStatus = 'Invalid';
      statusList.exercise6 = {value: false, text: exercise6Text};
    }

    if (this.image !== null) {
      statusList.image = {value: true, text: imageText};
    } else {
      primaryStatus = 'Invalid';
      statusList.image = {value: false, text: imageText};
    }

    if (this.categories.length > 0) {
      statusList.categories = {value: true, text: categoriesText};
    } else {
      primaryStatus = 'Invalid';
      statusList.categories = {value: false, text: categoriesText};
    }

    if (this.musclegroup.length > 0) {
      statusList.musclegroup = {value: true, text: musclegroupText};
    } else {
      primaryStatus = 'Invalid';
      statusList.musclegroup = {value: false, text: musclegroupText};
    }

    if (this.tags.length > 0) {
      statusList.tags = {value: true, text: tagsText};
    } else {
      primaryStatus = 'Invalid';
      statusList.tags = {value: false, text: tagsText};
    }

    if (this.intensity_level !== null) {
      statusList.intensity_level = {value: true, text: intensity_levelText};
    } else {
      primaryStatus = 'Invalid';
      statusList.intensity_level = {value: false, text: intensity_levelText};
    }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
